import Vue       from 'vue'
import Vuex      from 'vuex'
import modernizr  from 'modernizr'
import { sha256 } from 'js-sha256'
import ChunkFileReader from '../lib/chunks-file-reader'
import Eth         from 'ethjs-query'
import EthContract from 'ethjs-contract'

import eth_abi     from './ABI'
const eth_address = '0xd8a5bb8da68b3e5846807258b34010a9616b0731'

const STATUS_INITIAL     = 0
    , STATUS_HASHING     = 1
    , STATUS_HASHED      = 2
    , STATUS_FAILED      = 3
    , STATUS_PREPARED    = 4
    , STATUS_CAST_ERROR  = 5
    , STATUS_CASTED      = 6
    , STATUS_UNSUPPORTED = 100
    ;


const state = {
  isLoading: true
, shouldReload: false
, uploadedFiles: []
, uploadError: null
, contractArgs: {
    description: null
  , sha256: null
  }
, currentStatus: null
, uploadFieldName: 'photos'
, fileCount: 0
, currentProgress: 0
, dragDropSupported: false
, web3jsInited: false
, web3network: null
, web3account: null
, casterContract: null
, web3js: null
, web3Transaction: null
, gasPrice: 0
, checkCastResult: {}
, transferCastError: null
, transferCastResult: {}
, updateDescriptionError: null
, updateDescriptionResult: {}
}

const mutations = {
  setIsLoading (state, isLoading) {
    Vue.set(state, 'isLoading', isLoading)
  }
, setShouldReload (state, shouldReload) {
    Vue.set(state, 'shouldReload', shouldReload)
  }
, setStateValue (state, { key, value }) {
    Vue.set(state, key, value)
  }
}


let web3js = null

const parseMetaMaskError = error => {
  if ( /'{"value":({.+})}'/.test(error.message) ) {
     let message = JSON.parse(RegExp.$1).message
     message = message.replace(/payload {.*}/, 'payload {...}')
     // (/Error: (transaction underpriced)/).test(message) && (message = RegExp.$1)
     if ( /(Error: transaction underpriced)$/.test(message) ) message = RegExp.$1
     return message
  } else {
    return 'Unknown error'
  }
}

const actions = {
  init ({ commit, dispatch }) {
    const status = (!('FormData' in window) || !modernizr.filereader)
                 ? STATUS_UNSUPPORTED
                 : STATUS_INITIAL
    commit('setStateValue', { key: 'currentStatus', value: status })

    if ( STATUS_UNSUPPORTED != state.currentStatus
        && null != window
        && null != window.document
    ) {
      var div = window.document.createElement('div') || {}
      const isDragDropSupported = (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
      commit('setStateValue', { key: 'dragDropSupported', value: isDragDropSupported })
    }
  }
, performHashing ({commit, dispatch}, { fieldName, file }) {
    const formData = new FormData()
    const sha256hash = sha256.create();
    let chunkNumber = 0;
    let bytesRead = 0;
    const reader = ChunkFileReader(file);
    if ( reader ) {
      commit('setStateValue', { key: 'currentStatus', value: STATUS_HASHING })
      commit('setStateValue', { key: 'uploadedFiles', value: { originalName: file.name } })
      // this.startHashing();
      reader.on('data', (data) => {
        sha256hash.update(data);
        chunkNumber++;
        bytesRead += data.byteLength;
        // this.hashingProgress( Math.round(100 * bytesRead / file.size) )
        // this.currentProgress =
        commit('setStateValue', { key: 'currentProgress', value: Math.round(100 * bytesRead / file.size) })
        if (0 == chunkNumber % 100)
          console.log(`chunkNumber ${chunkNumber}; bytesRead = ${bytesRead}, progress = ${state.currentProgress}`);
      });
      reader.on('end', () => {
        const digest_sha256 = sha256hash.hex();
        console.log('loaded file ', file, 'hash=', digest_sha256)
        formData.append(fieldName, file, file.name, digest_sha256);
        const uploadedFiles = [{originalName: file.name, sha256: digest_sha256}]
        commit('setStateValue', { key: 'currentStatus', value: STATUS_HASHED  })
        commit('setStateValue', { key: 'uploadedFiles', value: uploadedFiles  })
        // this.finishHashing({ uploadedFiles })
        // this.currentStatus = STATUS_HASHED;
        // save it
        // this.save(formData);
      });
    } else {
      commit('setStateValue', { key: 'currentStatus', value: STATUS_FAILED  })
    }
  }
, prepareToCast ({commit, dispatch}, { description }) {
    const sha256 = (state.uploadedFiles[0] || {}).sha256
    const contractArgs = Object.assign({}, state.contractArgs, { description, sha256 })
    commit('setStateValue', { key: 'contractArgs',  value: contractArgs })
    commit('setStateValue', { key: 'currentStatus', value: STATUS_PREPARED })
  }
, initWeb3JS ({commit, dispatch}) {
    if ('undefined' !== typeof web3) {
      // Use Mist/MetaMask's provider
      web3js = new Web3(web3.currentProvider);
    } else {
      console.log('No web3? You should consider trying MetaMask!')
      // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
      try {
        web3js = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"));
      } catch(error) {
        return null
      }
    }
    commit('setStateValue', { key: 'web3jsInited', value: (null != web3js) })
    if (web3js) {
      dispatch('getWeb3Network')
    }
    // dispatch('getAccount')
    return web3js
  }
, getWeb3Network ({commit, dispatch}) {
    if (null != web3js) {
      web3js.version.getNetwork((err, netId) => {
        switch (netId) {
          case "1":
            commit('setStateValue', { key: 'web3network', value: 'mainnet' })
            break
          case "2":
            commit('setStateValue', { key: 'web3network', value: 'Morden (deprecated)' })
            break
          case "3":
            commit('setStateValue', { key: 'web3network', value: 'ropsten (test)' })
            break
          case "4":
            commit('setStateValue', { key: 'web3network', value: 'Rinkeby (test)' })
            break
          case "42":
            commit('setStateValue', { key: 'web3network', value: 'Kovan (test)' })
            break
          default:
            commit('setStateValue', { key: 'web3network', value: 'unknown' })
        }
      })
    }
  }
, getAccount ({commit, dispatch}) {
    return ( null == state.web3account )
      ? web3js.eth.getAccounts((err, accs) => {
        if (err != null) {
          console.log('getAccount() error:', err)
          alert('There was an error fetching your accounts.');
          return;
        }
        if (accs.length === 0) {
          console.log(
            'Couldn\'t get any accounts! Make sure your Ethereum client is configured correctly.'
          )
          return
        }
        commit('setStateValue', { key: 'web3account', value: accs[0] })
        return accs[0]
      })
      : state.web3account
  }
, getGasPrice({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      web3.eth.getGasPrice((error, result) => {
        if (error) {
          reject(error)
        } else {
          commit('setStateValue', { key: 'gasPrice', value: Number(result) })
          resolve(state.gasPrice)
        }
      })
    })
  }
, castWeb3Contract ({commit, dispatch}) {
    const eth = new Eth(web3.currentProvider)
    const contract = new EthContract(eth)
    const casterContract = contract(eth_abi, '', {
      from: state.web3account
    , gasPrice: web3.toWei(state.gasPrice, 'wei')
    }).at(eth_address)
    return new Promise((resolve, reject) => {
      casterContract.castMedia(`0x${state.contractArgs.sha256}`, state.contractArgs.description, function(error, result) {
        if (null != error) {
          // console.log(error)
          const message = parseMetaMaskError(error)
          commit('setStateValue', { key: 'web3Error',     value: message           })
          commit('setStateValue', { key: 'currentStatus', value: STATUS_CAST_ERROR })
        } else if (null != result) {
          console.log('casterContract::castMedia(...) result:', result)
          commit('setStateValue', { key: 'web3Transaction', value: result        })
          commit('setStateValue', { key: 'currentStatus',   value: STATUS_CASTED })
        }
        return resolve(result)
      })
    })
  }
, resetCast ({commit, dispatch}) {
    commit('setStateValue', { key: 'web3Transaction', value: null })
    commit('setStateValue', { key: 'web3Error',       value: null })
  }
, checkCast({commit, dispatch}, sha256) {
    const eth = new Eth(web3.currentProvider)
    const contract = new EthContract(eth)
    const casterContract = contract(eth_abi, '', {
      from: state.web3account
    }).at(eth_address)
    const sha256sum = `0x${sha256 || state.contractArgs.sha256}`
    // console.log('checkCast : sha256sum = ', sha256sum)
    casterContract.getCast(sha256sum, function(error, result) {
      if (null != error) {
        console.log(typeof error, error)
      } else if (null != result) {
        // console.log(typeof result, result)
        commit('setStateValue', { key: 'checkCastResult', value: result })
      }
    })
  }
, checkCastReset({commit, dispatch}) {
    commit('setStateValue', { key: 'checkCastResult', value: null })
  }
, transferCastReset({ commit, dispatch }) {
    commit('setStateValue', { key: 'transferCastError',  value: null })
    commit('setStateValue', { key: 'transferCastResult', value: null })
  }
, transferCastOwnership({commit, dispatch}, { sha256, target }) {
    const eth = new Eth(web3.currentProvider)
    const contract = new EthContract(eth)
    const casterContract = contract(eth_abi, '', {
      from: state.web3account
    , gasPrice: web3.toWei(state.gasPrice, 'wei')
    }).at(eth_address)
    const sha256sum = `0x${sha256 || state.contractArgs.sha256}`.toLowerCase()
    const address   = `0x${target}`.toLowerCase()
    // console.log('transferCastOwnership : sha256sum =', sha256sum)
    // console.log('transferCastOwnership : target =', address)
    casterContract.transferCastOwnership(sha256sum, address, function(error, result) {
      if (null != error) {
        const message = parseMetaMaskError(error)
        console.log('error:', message)
        commit('setStateValue', { key: 'transferCastError',  value: message })
        // commit('setStateValue', { key: 'currentStatus', value: STATUS_CAST_ERROR })
      } else if (null != result) {
        // console.log(typeof result, result)
        commit('setStateValue', { key: 'transferCastError',  value: null })
        commit('setStateValue', { key: 'transferCastResult', value: result })
      }
    })
  }
, updateDescriptionReset({ commit, dispatch }) {
    commit('setStateValue', { key: 'updateDescriptionError',  value: null })
    commit('setStateValue', { key: 'updateDescriptionResult', value: null })
  }
, updateCastDescription({commit, dispatch}, { sha256, description }) {
    const eth = new Eth(web3.currentProvider)
    const contract = new EthContract(eth)
    const casterContract = contract(eth_abi, '', {
      from: state.web3account
    , gasPrice: web3.toWei(state.gasPrice, 'wei')
    }).at(eth_address)
    const sha256sum = `0x${sha256 || state.contractArgs.sha256}`.toLowerCase()
    // console.log('updateCastDescription : sha256sum =', sha256sum)
    // console.log('updateCastDescription : description =', description)
    casterContract.updateCastDescription(sha256sum, description, function(error, result) {
      if (null != error) {
        const message = parseMetaMaskError(error)
        console.log('error:', message)
        commit('setStateValue', { key: 'updateDescriptionError',  value: message })
        // commit('setStateValue', { key: 'currentStatus', value: STATUS_CAST_ERROR })
      } else if (null != result) {
        // console.log(typeof result, result)
        commit('setStateValue', { key: 'updateDescriptionError',  value: null })
        commit('setStateValue', { key: 'updateDescriptionResult', value: result })
      }
    })
  }
, donateWeb3({commit, dispatch}, value) {
    const eth = new Eth(web3.currentProvider)
    const contract = new EthContract(eth)
    const casterContract = contract(eth_abi, '', {
      from: state.web3account
    , gasPrice: web3.toWei(state.gasPrice, 'wei')
    , value: 1e18 * value
    }).at(eth_address)

    casterContract.Donate(function(error, result) {
      if (null != error) {
        const message = parseMetaMaskError(error)
        commit('setStateValue', { key: 'donateError',  value: message })
        commit('setStateValue', { key: 'donateResult', value: null    })
      } else if (null != result) {
        commit('setStateValue', { key: 'donateError',  value: null   })
        commit('setStateValue', { key: 'donateResult', value: result })
      }
    })
  }
// , reset() { // reset form to initial state
//     this.currentStatus = STATUS_INITIAL
//     this.uploadedFiles = []
//     this.uploadError = null
//     this.currentProgress = 0
//   }
}

const getters = {
    isInitial()     { return STATUS_INITIAL     === state.currentStatus }
  , isHashing()     { return STATUS_HASHING     === state.currentStatus }
  , isHashed()      { return STATUS_HASHED      === state.currentStatus }
  , isFailed()      { return STATUS_FAILED      === state.currentStatus }
  , isPrepared()    { return STATUS_PREPARED    === state.currentStatus }
  , isCastError()   { return STATUS_CAST_ERROR  === state.currentStatus }
  , isCasted()      { return STATUS_CASTED      === state.currentStatus }
  , isUnsupported() { return STATUS_UNSUPPORTED === state.currentStatus }
}

const plugins = [
]

export function createStore () {
  const store = new Vuex.Store({
      state
    , modules: {}
    , actions
    , getters
    , mutations
    , plugins
    , strict: process.env.NODE_ENV !== 'production'
  })

  store.watch((state) => state.shouldReload, (newValue, oldValue) => {
    console.log('shouldReload has changed:', oldValue, '=>', newValue)
  })

  return store
}



// WEBPACK FOOTER //
// ./src/store/index.js